
export default {
    head() {
        return {
            title: `${this.capitalize(this.epci.nice_name)} - Toutes les communes - ${this.$config.siteTitle}`,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: `La ${this.epci.phrase} compte ${this.formatNumericValue(this.epci.population)}` +
                        ` habitants répartis sur ${this.epci.cities_count} communes. La ville la plus importante est ${this.epci.main_city.full_name}.`
                }
            ]
        }
    },

    async asyncData({ params, $axios, $config: { baseApiURL } }) {
        const props = await $axios.$get(`${baseApiURL}/intercommunalites/${params.epci}`)
        return {
            cities: props.cities,
            epci: props.epci,
            reviews: props.reviews,
            breadcrumbs: props.breadcrumbs,
        }
    },
    computed: {
        sortedCities() {
            return this.cities
                .sort((a, b) => {
                    return a.full_name.localeCompare(b.full_name);
                })
                .map((city, index, arr) => {
                    const prevCity = arr[index - 1];
                    city.firstLetter = city.name.charAt(0);
                    city.firstLetterHasChanged = (prevCity?.name.charAt(0) !== city.firstLetter) ? true : false;

                    return city;
                });
        }
    }
}

